import axios from "./userInstance"
import { Permission } from "@/types/role"

export default async (roleName: string) => {
  try {
    const response = await axios.get(`/role/${encodeURIComponent(roleName)}/permissions`)
    return response.data
  } catch (error) {
    return [] as Permission[]
  }
}
